import React, { ChangeEvent } from 'react'

import { InlineMenu, Input, SectionSubtitle } from '../..'
import { useUser } from '../../../context'
import { AnyProfile, Student } from '../../../types'
import { Spacer } from '../../global'
import FormResponsesSection from '../FormResponsesSection'

const StudentsSection = ({
  type,
  editedProfile,
  handleMenuChange,
  handleChange,
}: {
  type?: string | null
  editedProfile: Student | AnyProfile | null
  handleMenuChange: (
    filterName: string,
    value: string | string[] | null,
  ) => void
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
}) => {
  const { onEditionMode, userRole } = useUser()

  const inNewUser = type === 'new-user' ? true : onEditionMode

  return (
    editedProfile && (
      <>
        <Spacer height={16} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Tipo de experiencia
        </SectionSubtitle>
        <Spacer height={16} />
        <InlineMenu
          userType={userRole === 'admin' ? userRole : editedProfile.role}
          menuName="experticeMenuStudent"
          activeFilter={editedProfile.experienceType}
          setActiveFilter={(value) => handleMenuChange('experienceType', value)}
          isDisabled={!inNewUser}
          isProfile={true}
        />
        <Spacer height={36} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Tipo de actividad en Diga-ah!
        </SectionSubtitle>
        <Spacer height={16} />
        <InlineMenu
          userType={userRole}
          menuName="activitiesStudent"
          activeFilter={editedProfile.activities}
          setActiveFilter={(value) => handleMenuChange('activities', value)}
          isDisabled={!inNewUser}
          isProfile={true}
        />
        <Spacer height={42} />
        <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
          Elige a los tutores:
        </SectionSubtitle>
        <Spacer height={16} />

        <InlineMenu
          userType={userRole}
          menuName="professorsNames"
          activeFilter={(editedProfile as Student).professors}
          setActiveFilter={(value) => handleMenuChange('professors', value)}
          isDisabled={!inNewUser}
          isProfile={true}
        />

        {((editedProfile as Student).dropboxLink || type === 'new-user') && (
          <>
            <Spacer height={42} />
            <SectionSubtitle fontWeight={500} fontSize={16} lineHeight={21}>
              Link de Dropbox-Grabaciones:
            </SectionSubtitle>
            <Spacer height={16} />
            {!inNewUser ? (
              <div className="dropbox-link">
                <a href={(editedProfile as Student).dropboxLink}>
                  Dropbox-Grabaciones
                </a>
              </div>
            ) : (
              <Input
                type="text"
                name="dropboxLink"
                id="dropboxLink"
                placeholder={(editedProfile as Student).dropboxLink}
                defaultValue={(editedProfile as Student).dropboxLink}
                onChange={handleChange}
              />
            )}
          </>
        )}
        {!inNewUser && (
          <FormResponsesSection
            hasForm={editedProfile.form ? true : false}
            form={
              typeof editedProfile.form !== 'boolean'
                ? editedProfile.form
                : undefined
            }
          />
        )}
      </>
    )
  )
}

export default StudentsSection
